export default "__VITE_ASSET__CrUNnymN__"